var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path6, _polygon, _path7, _path8, _rect7, _path9, _rect8, _path10, _path11, _polygon2, _path12, _path13, _circle, _path14, _path15, _polygon3, _circle2, _path16, _rect9, _path17, _path18, _path19, _rect10, _path20, _path21, _path22, _path23;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRefer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 678.62,
    height: 606.19,
    viewBox: "0 0 678.62 606.19",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "uuid-fb20b2b5-bc5b-4117-a1ee-c5d1a8aa62bd-133",
    d: "m183.39,55.89c2.75-6.95,8.68-11.07,13.24-9.21,4.56,1.86,6.03,9.01,3.28,15.96-1.06,2.79-2.79,5.27-5.06,7.23l-12.04,29.28-14.07-6.29,13.36-28.2c-.3-3.01.14-6.02,1.28-8.78,0,0,0,0,0,0Z",
    fill: "#a0616a",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m132.94,242.82s-20.19-9.78-18.79-16.8c1.4-7.03,61.55-156.74,61.55-156.74l27.85,18.3-70.61,155.25Z",
    fill: "#e6e6e6",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m435.76,606.19h-193.12c-28.09,0-50.94-22.85-50.94-50.94V50.94c0-28.09,22.85-50.94,50.94-50.94h193.12c28.09,0,50.94,22.85,50.94,50.94v504.31c0,28.09-22.85,50.94-50.94,50.94Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m435.9,592.4h-193.4c-20.79,0-37.71-16.92-37.71-37.71V50.51c0-20.79,16.92-37.71,37.71-37.71h193.4c20.79,0,37.71,16.92,37.71,37.71v504.18c0,20.79-16.92,37.71-37.71,37.71Z",
    fill: "#fff",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m366.55,46.36h-54.69c-7.22,0-13.09-5.87-13.09-13.09s5.87-13.09,13.09-13.09h54.69c7.22,0,13.09,5.87,13.09,13.09s-5.87,13.09-13.09,13.09Z",
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 232.82,
    y: 201.79,
    width: 212.77,
    height: 29.95,
    rx: 14.98,
    ry: 14.98,
    fill: "#000000",
    strokeWidth: 0
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237.24,
    y: 176.9,
    width: 65.71,
    height: 5.22,
    rx: 2.61,
    ry: 2.61,
    fill: "#000000",
    strokeWidth: 0
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 232.82,
    y: 303.18,
    width: 212.77,
    height: 29.95,
    rx: 14.98,
    ry: 14.98,
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 237.24,
    y: 278.28,
    width: 65.71,
    height: 5.22,
    rx: 2.61,
    ry: 2.61,
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 232.82,
    y: 404.56,
    width: 212.77,
    height: 29.95,
    rx: 14.98,
    ry: 14.98,
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 237.24,
    y: 379.67,
    width: 65.71,
    height: 5.22,
    rx: 2.61,
    ry: 2.61,
    fill: "#d7d7d8",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m537.95,123.4s-20.62,2.33-21.95,34.25c-1.11,26.6-3.37,41.43,7.45,46.98,3.87,1.98,8.42,2.16,12.55.8l44.18-14.53s.67-47.89-14.63-59.52c-15.3-11.64-27.6-7.98-27.6-7.98Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "562.31 196.78 539.95 204.13 539.95 171.95 560.23 171.95 562.31 196.78",
    fill: "#ffb6b6",
    strokeWidth: 0
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-e639489a-d12b-4c23-97cb-2af79ea40b7d-134",
    d: "m493.96,379.49c-1.21,7.37-6.13,12.66-10.98,11.81-4.85-.85-7.81-7.52-6.59-14.9.44-2.95,1.61-5.75,3.41-8.14l5.54-31.17,15.08,3.16-7.07,30.39c.93,2.88,1.14,5.91.61,8.85,0,0,0,0,0,0Z",
    fill: "#ffb6b6",
    strokeWidth: 0
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-56df27a3-bbb6-4bd2-b7f5-888148e3fe66-135",
    d: "m615.85,375.91c1.49,7.32-1.24,14.01-6.08,14.94-4.84.93-9.97-4.26-11.45-11.58-.63-2.92-.53-5.94.29-8.82l-5.89-31.11,15.22-2.41,4.19,30.92c1.89,2.36,3.16,5.12,3.72,8.06,0,0,0,0,0,0Z",
    fill: "#ffb6b6",
    strokeWidth: 0
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 532.96,
    y: 557.07,
    width: 20.94,
    height: 29.71,
    fill: "#ffb6b6",
    strokeWidth: 0
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m512.57,604.77c-2.2,0-4.16-.05-5.64-.19-5.56-.51-10.87-4.62-13.54-7.02-1.2-1.08-1.58-2.8-.96-4.28h0c.45-1.06,1.34-1.86,2.45-2.17l14.7-4.2,23.8-16.06.27.48c.1.18,2.44,4.39,3.22,7.23.3,1.08.22,1.98-.23,2.68-.31.48-.75.76-1.1.92.43.45,1.78,1.37,5.94,2.03,6.07.96,7.35-5.33,7.4-5.59l.04-.21.18-.12c2.89-1.86,4.67-2.71,5.28-2.53.38.11,1.02.31,2.75,17.44.17.54,1.38,4.48.56,8.25-.89,4.1-18.81,2.69-22.4,2.37-.1.01-13.52.97-22.71.97Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 602.03,
    y: 537.03,
    width: 20.94,
    height: 29.71,
    transform: "translate(-199.26 407.72) rotate(-31.95)",
    fill: "#ffb6b6",
    strokeWidth: 0
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m589.93,600.7c-2.46,0-4.72-.3-6.33-.58-1.58-.28-2.82-1.54-3.08-3.12h0c-.18-1.14.15-2.29.93-3.14l10.25-11.34,11.7-26.22.48.26c.18.1,4.39,2.43,6.56,4.43.83.76,1.24,1.57,1.22,2.4-.01.58-.23,1.04-.45,1.37.6.16,2.23.22,6.11-1.42,5.66-2.39,3.42-8.41,3.32-8.66l-.08-.2.09-.19c1.47-3.11,2.52-4.77,3.14-4.94.39-.11,1.03-.28,11.56,13.35.43.36,3.54,3.07,4.84,6.7,1.41,3.95-14.54,12.24-17.75,13.86-.1.08-16.79,12.21-23.65,15.66-2.72,1.37-5.94,1.79-8.87,1.79Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m569.32,308.62h-58.63l-5.32,54.54,23.28,201.52h29.93l-11.97-116.39,48.55,105.08,26.6-18.62-37.91-98.1s13.54-85.46,2.9-106.75c-10.64-21.28-17.43-21.28-17.43-21.28Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "598.48 311.95 496.73 311.95 533.31 191.57 573.88 191.57 598.48 311.95",
    fill: "#000000",
    strokeWidth: 0
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m539.71,191.59s-25.27-.67-27.93,5.99c-2.66,6.65-33.92,164.94-33.92,164.94h20.62l41.24-170.93Z",
    fill: "#000000",
    strokeWidth: 0
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m556.15,191.73s22.26-2.82,24.92,3.83c2.66,6.65,33.92,164.94,33.92,164.94h-20.62s-38.22-168.77-38.22-168.77Z",
    fill: "#000000",
    strokeWidth: 0
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 542.72,
    cy: 158.58,
    r: 22.28,
    fill: "#ffb6b6",
    strokeWidth: 0
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m536.62,131.71s-12.26,49.79,1.37,73.06l-19.2-4.08s-7.44-54.49,7.52-64.4l10.31-4.59Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m678.62,603.58c0,.83-.67,1.5-1.5,1.5H1.5c-.83,0-1.5-.67-1.5-1.5s.67-1.5,1.5-1.5h675.62c.83,0,1.5.67,1.5,1.5Z",
    fill: "#2e2e41",
    strokeWidth: 0
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "115.1 174.73 140.71 183.15 140.71 146.28 117.47 146.28 115.1 174.73",
    fill: "#a0616a",
    strokeWidth: 0
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 137.54,
    cy: 130.96,
    r: 25.52,
    fill: "#a0616a",
    strokeWidth: 0
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m131.04,132.96l3.52,4.27,6.36-11.14s8.12.42,8.12-5.61,7.45-6.2,7.45-6.2c0,0,10.55-18.42-11.3-13.57,0,0-15.16-10.38-22.69-1.51,0,0-23.11,11.64-16.5,31.9l10.99,20.89,2.49-4.73s-1.51-19.85,11.56-14.32Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 107.42,
    y: 557.4,
    width: 20.94,
    height: 29.71,
    transform: "translate(235.77 1144.5) rotate(-180)",
    fill: "#a0616a",
    strokeWidth: 0
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m126.04,604.12c-3.58.32-21.5,1.74-22.4-2.37-.82-3.77.39-7.71.56-8.25,1.72-17.14,2.36-17.33,2.75-17.44.61-.18,2.39.67,5.28,2.53l.18.12.04.21c.05.27,1.33,6.56,7.4,5.59,4.16-.66,5.51-1.58,5.94-2.03-.35-.16-.79-.44-1.1-.92-.45-.7-.53-1.6-.23-2.68.78-2.85,3.12-7.06,3.22-7.23l.27-.48,23.8,16.06,14.7,4.2c1.11.32,2,1.11,2.45,2.17h0c.62,1.48.24,3.2-.96,4.28-2.67,2.4-7.97,6.51-13.54,7.02-1.48.14-3.44.19-5.64.19-9.19,0-22.61-.95-22.71-.97Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m155.1,301.25l-54.93-2.81s-8.42,31.92,2.22,65.18l1.28,200.29h31.04l29.26-206.61-8.87-56.05Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m145.83,167.65l-30.15-16s-32.49,47.48-28,73.2c4.5,25.72,12.48,73.6,12.48,73.6l66.51,2.81-11.61-94.29-9.23-39.32Z",
    fill: "#e6e6e6",
    strokeWidth: 0
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 122.31,
    y: 557.4,
    width: 20.94,
    height: 29.71,
    transform: "translate(265.56 1144.5) rotate(-180)",
    fill: "#a0616a",
    strokeWidth: 0
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m140.94,604.12c-3.58.32-21.5,1.74-22.4-2.37-.82-3.77.39-7.71.56-8.25,1.72-17.14,2.36-17.33,2.75-17.44.61-.18,2.39.67,5.28,2.53l.18.12.04.21c.05.27,1.33,6.56,7.4,5.59,4.16-.66,5.51-1.58,5.94-2.03-.35-.16-.79-.44-1.1-.92-.45-.7-.53-1.6-.23-2.68.78-2.85,3.12-7.06,3.22-7.23l.27-.48,23.8,16.06,14.7,4.2c1.11.32,2,1.11,2.45,2.17h0c.62,1.48.24,3.2-.96,4.28-2.67,2.4-7.97,6.51-13.54,7.02-1.48.14-3.44.19-5.64.19-9.19,0-22.61-.95-22.71-.97Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m166.67,301.25l-66.51-2.81s-8.42,31.92,2.22,65.18l12.86,200.29h31.04l29.26-206.61-8.87-56.05Z",
    fill: "#2f2e41",
    strokeWidth: 0
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "uuid-e3777ca2-fb97-40f5-b301-a7df89d05aed-136",
    d: "m192.22,353.55c2.45,7.06.64,14.05-4.03,15.62-4.67,1.56-10.44-2.89-12.89-9.96-1.02-2.81-1.32-5.82-.88-8.78l-9.97-30.05,14.76-4.41,8.27,30.09c2.19,2.09,3.82,4.66,4.75,7.49,0,0,0,0,0,0Z",
    fill: "#a0616a",
    strokeWidth: 0
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m108.54,178.95s21.68-5.76,25.21.48c3.52,6.24,55.57,158.96,55.57,158.96l-33.04,4.3-47.73-163.74Z",
    fill: "#e6e6e6",
    strokeWidth: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefer);
export default __webpack_public_path__ + "static/media/refer.4da4b5c2ab838958da480be088cedfb4.svg";
export { ForwardRef as ReactComponent };